import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FormDataProvider } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getGraphqlClient } from "@/api/graphql/client";
import FormData from "@/components/FormData/component";
import { CardProGraphQLProvider } from "@/components/FormData/providers/cardProWiring/provider";
import { FormDataProviders } from "@/components/FormData/providers/formData/provider";
import { Loading } from "@/components/shared/Loading/component";
import { useAbilities } from "@/hooks/ability/hooks";

const FormDataScreen = () => {
  const { cannot, isLoading } = useAbilities();
  const router = useNavigate();
  const { t } = useTranslation("formData");
  const formDataProviders = new FormDataProviders(t, getGraphqlClient());
  const cardProProviders = new CardProGraphQLProvider(getGraphqlClient());

  useEffect(() => {
    if (!isLoading && cannot("MAINTAINER")) {
      router({ to: "/" });
    }
  }, [cannot, isLoading, router]);

  return (
    <Loading isLoading={isLoading}>
      <FormDataProvider
        providers={formDataProviders}
        allowDebug={true}
        dataTestIdPrefix={"bo-"}
      >
        <FormData cardProProviders={cardProProviders} />
      </FormDataProvider>
    </Loading>
  );
};

export const Route = createFileRoute("/formdata/")({
  component: () => <FormDataScreen />,
});
